import { AllOffersWebList } from '@/features/earn/components/discover/AllOffersWebList';
import { UserEarnOfferListResponseDataItem } from '@utx/utx-client';
import { SxProp, View } from 'dripsy';
import { useState } from 'react';
import { SegmentSelect } from '../buttons/segmentSelect/SegmentSelect';

interface NoAnimationTabViewProps<T> {
  tabs: Array<{
    name: string;
    title?: string;
    component?: React.ComponentType<any>;
    children?: React.ReactNode;
  }>;
  sx?: SxProp;
  loading?: boolean;
  data: Array<T>;
}

export const NoAnimationTabView = <T extends unknown>({ tabs, loading, data }: NoAnimationTabViewProps<T>) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <View sx={styles.container}>
      {/* Button for Changing Tab */}
      <View sx={{ width: 'fit-content' }}>
        <SegmentSelect
          data={tabs.map((tab, i) => ({ labelKey: tab.name, value: i }))}
          value={tabIndex}
          onValueChange={setTabIndex}
          buttonWidth={150}
        />
      </View>
      {/* Tab Content */}
      <View sx={styles.contentContainer}>
        <AllOffersWebList loading={loading} offers={data[tabIndex] as Array<UserEarnOfferListResponseDataItem>} />
      </View>
    </View>
  );
};

enum StyleName {
  container = 'container',
  contentContainer = 'contentContainer'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    mt: '$6'
  },
  contentContainer: {}
};
